import { Component, OnInit, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { NavigationContextService } from '../../../core/services/navigation-context.service';

// PrimeNG 21 Imports
import { TabsModule } from 'primeng/tabs';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { UnderConstructionComponent } from '../../../core/shared/under-construction/under-construction.component';

@Component({
  selector: 'app-home',
  standalone: true,
  providers: [MessageService, ConfirmationService],
  imports: [
    CommonModule,
    RouterModule,
    TabsModule,
    ButtonModule,
    TableModule,
    ToastModule,
    ConfirmDialogModule,
    DividerModule,
    UnderConstructionComponent,
  ],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class HomeComponent implements OnInit {
  private titleService = inject(Title);
  private navigationContext = inject(NavigationContextService);
  // Signal-based state for Angular 21
  selectedTabIndex = signal<string>('0');

  blockingStartDates = signal<any[]>([]);
  blockingEndDates = signal<any[]>([]);

  get contractTemplatesRoute(): string {
    return `/axa/${this.navigationContext.getDomainPrefix()}-contract-templates`;
  }

  get contractSectionsRoute(): string {
    return `/axa/${this.navigationContext.getDomainPrefix()}-contract-sections`;
  }

  readonly personalDataColumns = [
    { name: 'ID Docente', key: 'facultyId' },
    { name: 'Nome', key: 'firstName' },
    { name: 'Cognome', key: 'lastName' },
    { name: 'Nominativo', key: 'fullName' },
    { name: 'Cittadinanza 1', key: 'citizenship' },
    { name: 'Cittadinanza 2', key: 'citizenship2', optional: true },
    { name: 'Sesso', key: 'gender' },
    { name: 'Codice Fiscale', key: 'taxCode' },
    { name: 'Data di nascita', key: 'dateOfBirth' },
    { name: 'Luogo di nascita', key: 'placeOfBirth' },
    { name: 'Età', key: 'age' },
    { name: "Fascia d'età", key: 'ageRange' },
    { name: 'Email', key: 'email' },
  ];

  readonly roleDataColumns = [
    { name: 'ID Posizione', key: 'facultyPositionId' },
    { name: 'ID Docente', key: 'facultyId' },
    { name: 'Nominativo', key: 'fullName' },
    { name: 'Piano Strategico', key: 'isStrategicPlan' },
    { name: 'Codice Programmazione', key: 'planningCode' },
    { name: 'Modalità di Nomina', key: 'appointmentMethod' },
    { name: 'Stato Pratica della Posizione', key: 'positionApplicationStatus' },
    { name: 'Nuova Posizione / Sostituzione', key: 'newPositionReplacement' },
    { name: 'Consolidata', key: 'isConsolidated' },
    { name: 'Stato Posizione', key: 'positionStatus' },
    { name: 'Qualifica', key: 'qualification' },
    { name: 'Data Inizio Prevista', key: 'expectedStartDate' },
    { name: 'Data Inizio Ufficiale', key: 'officialStartDate' },
    { name: 'Data Scadenza Prevista', key: 'expectedEndDate' },
    { name: 'Data Scadenza Ufficiale', key: 'officialEndDate' },
    { name: 'Note alla Nomina', key: 'appointmentNotes' },
  ];

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Home Backoffice - PalEasy');
    // Initialization logic here
  }

  // Example of how to use PrimeNG dialogs instead of NzModal
  showInfo() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'You accepted' });
      },
    });
  }
}
